var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgPayments = function SvgPayments(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37.5,
    height: 33.447,
    viewBox: "0 0 37.5 33.447",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1056",
    "data-name": "Group 1056",
    transform: "translate(1.25 1.25)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1042",
    "data-name": "Path 1042",
    d: "M-800.661,277.156c.087,1.737-1.813,3.243-4.245,3.365s-4.473-1.187-4.56-2.923,1.813-3.244,4.245-3.366S-800.749,275.42-800.661,277.156Z",
    transform: "translate(819.073 -265.712)",
    fill: "none",
    stroke: "#06016c",
    strokeMiterlimit: 10,
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1055",
    "data-name": "Group 1055"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1043",
    "data-name": "Path 1043",
    d: "M-792.612,266.669l-7.98,26.341h-18.06l7.98-26.341",
    transform: "translate(819.073 -265.712)",
    fill: "none",
    stroke: "#06016c",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1044",
    "data-name": "Path 1044",
    d: "M-788.735,266.839l-9.021,29.82h-18.691",
    transform: "translate(819.073 -265.712)",
    fill: "none",
    stroke: "#06016c",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1045",
    "data-name": "Path 1045",
    d: "M-816.3,274.067h-.883a1.894,1.894,0,0,1-1.889-1.889V267.6a1.894,1.894,0,0,1,1.889-1.889h31.222a1.894,1.894,0,0,1,1.889,1.889v4.577a1.894,1.894,0,0,1-1.889,1.889h-2.092",
    transform: "translate(819.073 -265.712)",
    fill: "none",
    stroke: "#2699fb",
    strokeLinejoin: "round",
    strokeWidth: 2.5
  })))));
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPayments, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Payments.aef8177d.svg";
export { ForwardRef as ReactComponent };